var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"rp-sidebar"},[_c('div',{staticClass:"rp-sidebar__title"},[_c('r-title',{attrs:{"type":"subtitle-1"}},[_vm._v(" Роли и разрешения ")])],1),_c('rp-sidebar-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }